/* tslint:disable */
/* eslint-disable */
/**
 * NN.CustomerPortal.ApiApp.General
 * GeneralAPIs
 *
 * The version of the OpenAPI document: 1.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ActiveDirectoryUserIdRequest,
  ActiveDirectoryUserIdResponse,
  AdditionalRegisterDataRequest,
  AesGcmEncryptResponse,
  EnableUserAccountRequest,
  EncryptUserDetailInfoRequest,
  ErrorResponse,
  FinalizeRegisterDataRequest,
  LocalAccountRegistrationRequest,
  RegisterRequest,
  RegisterRequestV2,
  RegisterResponse,
  RegisterResponseV2,
  RegisterValidateLoginRequest,
  ValidateBirthNumberRequest,
  ValidateBirthNumberResponse,
  ValidateLocalAccountRequest,
  ValidateLocalAccountResponse,
} from '../models/index';
import {
    ActiveDirectoryUserIdRequestFromJSON,
    ActiveDirectoryUserIdRequestToJSON,
    ActiveDirectoryUserIdResponseFromJSON,
    ActiveDirectoryUserIdResponseToJSON,
    AdditionalRegisterDataRequestFromJSON,
    AdditionalRegisterDataRequestToJSON,
    AesGcmEncryptResponseFromJSON,
    AesGcmEncryptResponseToJSON,
    EnableUserAccountRequestFromJSON,
    EnableUserAccountRequestToJSON,
    EncryptUserDetailInfoRequestFromJSON,
    EncryptUserDetailInfoRequestToJSON,
    ErrorResponseFromJSON,
    ErrorResponseToJSON,
    FinalizeRegisterDataRequestFromJSON,
    FinalizeRegisterDataRequestToJSON,
    LocalAccountRegistrationRequestFromJSON,
    LocalAccountRegistrationRequestToJSON,
    RegisterRequestFromJSON,
    RegisterRequestToJSON,
    RegisterRequestV2FromJSON,
    RegisterRequestV2ToJSON,
    RegisterResponseFromJSON,
    RegisterResponseToJSON,
    RegisterResponseV2FromJSON,
    RegisterResponseV2ToJSON,
    RegisterValidateLoginRequestFromJSON,
    RegisterValidateLoginRequestToJSON,
    ValidateBirthNumberRequestFromJSON,
    ValidateBirthNumberRequestToJSON,
    ValidateBirthNumberResponseFromJSON,
    ValidateBirthNumberResponseToJSON,
    ValidateLocalAccountRequestFromJSON,
    ValidateLocalAccountRequestToJSON,
    ValidateLocalAccountResponseFromJSON,
    ValidateLocalAccountResponseToJSON,
} from '../models/index';

export interface ActiveDirectoryUserIdPostRequest {
    activeDirectoryUserIdRequest: ActiveDirectoryUserIdRequest;
}

export interface AuthorizeRegisterPostRequest {
    registerValidateLoginRequest?: RegisterValidateLoginRequest;
}

export interface EnableUserAccountPostRequest {
    enableUserAccountRequest: EnableUserAccountRequest;
}

export interface EncryptUserDetailInfoPostRequest {
    encryptUserDetailInfoRequest: EncryptUserDetailInfoRequest;
}

export interface FinalizeUserRegistrationPostRequest {
    finalizeRegisterDataRequest: FinalizeRegisterDataRequest;
}

export interface LocalAccountRegistrationPostRequest {
    localAccountRegistrationRequest: LocalAccountRegistrationRequest;
}

export interface LocalAccountRegistrationV2PostRequest {
    localAccountRegistrationRequest: LocalAccountRegistrationRequest;
}

export interface RegisterPostRequest {
    registerRequest: RegisterRequest;
}

export interface RegisterV2PostRequest {
    registerRequestV2: RegisterRequestV2;
}

export interface SaveAdditionalRegisterDataPostRequest {
    additionalRegisterDataRequest: AdditionalRegisterDataRequest;
}

export interface SaveAdditionalRegisterDataV2PostRequest {
    additionalRegisterDataRequest: AdditionalRegisterDataRequest;
}

export interface ValidateBirthNumberPostRequest {
    validateBirthNumberRequest: ValidateBirthNumberRequest;
}

export interface ValidateLocalAccountPostRequest {
    validateLocalAccountRequest: ValidateLocalAccountRequest;
}

/**
 * 
 */
export class RegistrationApi extends runtime.BaseAPI {

    /**
     * Decipher user (object) id from a symmetric cipher
     */
    async activeDirectoryUserIdPostRaw(requestParameters: ActiveDirectoryUserIdPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ActiveDirectoryUserIdResponse>> {
        if (requestParameters['activeDirectoryUserIdRequest'] == null) {
            throw new runtime.RequiredError(
                'activeDirectoryUserIdRequest',
                'Required parameter "activeDirectoryUserIdRequest" was null or undefined when calling activeDirectoryUserIdPost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/active-directory-user-id`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ActiveDirectoryUserIdRequestToJSON(requestParameters['activeDirectoryUserIdRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ActiveDirectoryUserIdResponseFromJSON(jsonValue));
    }

    /**
     * Decipher user (object) id from a symmetric cipher
     */
    async activeDirectoryUserIdPost(requestParameters: ActiveDirectoryUserIdPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ActiveDirectoryUserIdResponse> {
        const response = await this.activeDirectoryUserIdPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Validate ciper, tag, nonce
     */
    async authorizeRegisterPostRaw(requestParameters: AuthorizeRegisterPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ActiveDirectoryUserIdResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/authorize-register`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: RegisterValidateLoginRequestToJSON(requestParameters['registerValidateLoginRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ActiveDirectoryUserIdResponseFromJSON(jsonValue));
    }

    /**
     * Validate ciper, tag, nonce
     */
    async authorizeRegisterPost(requestParameters: AuthorizeRegisterPostRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ActiveDirectoryUserIdResponse> {
        const response = await this.authorizeRegisterPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Enable user account
     */
    async enableUserAccountPostRaw(requestParameters: EnableUserAccountPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ActiveDirectoryUserIdResponse>> {
        if (requestParameters['enableUserAccountRequest'] == null) {
            throw new runtime.RequiredError(
                'enableUserAccountRequest',
                'Required parameter "enableUserAccountRequest" was null or undefined when calling enableUserAccountPost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/enable-user-account`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: EnableUserAccountRequestToJSON(requestParameters['enableUserAccountRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ActiveDirectoryUserIdResponseFromJSON(jsonValue));
    }

    /**
     * Enable user account
     */
    async enableUserAccountPost(requestParameters: EnableUserAccountPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ActiveDirectoryUserIdResponse> {
        const response = await this.enableUserAccountPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Encrypt provided user detail info
     */
    async encryptUserDetailInfoPostRaw(requestParameters: EncryptUserDetailInfoPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['encryptUserDetailInfoRequest'] == null) {
            throw new runtime.RequiredError(
                'encryptUserDetailInfoRequest',
                'Required parameter "encryptUserDetailInfoRequest" was null or undefined when calling encryptUserDetailInfoPost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/encrypt-user-detail-info`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: EncryptUserDetailInfoRequestToJSON(requestParameters['encryptUserDetailInfoRequest']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Encrypt provided user detail info
     */
    async encryptUserDetailInfoPost(requestParameters: EncryptUserDetailInfoPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.encryptUserDetailInfoPostRaw(requestParameters, initOverrides);
    }

    /**
     * Finalize register user
     */
    async finalizeUserRegistrationPostRaw(requestParameters: FinalizeUserRegistrationPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ActiveDirectoryUserIdResponse>> {
        if (requestParameters['finalizeRegisterDataRequest'] == null) {
            throw new runtime.RequiredError(
                'finalizeRegisterDataRequest',
                'Required parameter "finalizeRegisterDataRequest" was null or undefined when calling finalizeUserRegistrationPost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/finalize-user-registration`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: FinalizeRegisterDataRequestToJSON(requestParameters['finalizeRegisterDataRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ActiveDirectoryUserIdResponseFromJSON(jsonValue));
    }

    /**
     * Finalize register user
     */
    async finalizeUserRegistrationPost(requestParameters: FinalizeUserRegistrationPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ActiveDirectoryUserIdResponse> {
        const response = await this.finalizeUserRegistrationPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Validate provided registration data adn create AD user
     */
    async localAccountRegistrationPostRaw(requestParameters: LocalAccountRegistrationPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AesGcmEncryptResponse>> {
        if (requestParameters['localAccountRegistrationRequest'] == null) {
            throw new runtime.RequiredError(
                'localAccountRegistrationRequest',
                'Required parameter "localAccountRegistrationRequest" was null or undefined when calling localAccountRegistrationPost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/local-account-registration`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: LocalAccountRegistrationRequestToJSON(requestParameters['localAccountRegistrationRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AesGcmEncryptResponseFromJSON(jsonValue));
    }

    /**
     * Validate provided registration data adn create AD user
     */
    async localAccountRegistrationPost(requestParameters: LocalAccountRegistrationPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AesGcmEncryptResponse> {
        const response = await this.localAccountRegistrationPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Validate provided registration data adn create AD user
     */
    async localAccountRegistrationV2PostRaw(requestParameters: LocalAccountRegistrationV2PostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AesGcmEncryptResponse>> {
        if (requestParameters['localAccountRegistrationRequest'] == null) {
            throw new runtime.RequiredError(
                'localAccountRegistrationRequest',
                'Required parameter "localAccountRegistrationRequest" was null or undefined when calling localAccountRegistrationV2Post().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/v2/local-account-registration`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: LocalAccountRegistrationRequestToJSON(requestParameters['localAccountRegistrationRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AesGcmEncryptResponseFromJSON(jsonValue));
    }

    /**
     * Validate provided registration data adn create AD user
     */
    async localAccountRegistrationV2Post(requestParameters: LocalAccountRegistrationV2PostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AesGcmEncryptResponse> {
        const response = await this.localAccountRegistrationV2PostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Try resolve information from registration into a PID
     */
    async registerPostRaw(requestParameters: RegisterPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RegisterResponse>> {
        if (requestParameters['registerRequest'] == null) {
            throw new runtime.RequiredError(
                'registerRequest',
                'Required parameter "registerRequest" was null or undefined when calling registerPost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/register`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: RegisterRequestToJSON(requestParameters['registerRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RegisterResponseFromJSON(jsonValue));
    }

    /**
     * Try resolve information from registration into a PID
     */
    async registerPost(requestParameters: RegisterPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RegisterResponse> {
        const response = await this.registerPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Try resolve information from registration into a MPK
     */
    async registerV2PostRaw(requestParameters: RegisterV2PostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RegisterResponseV2>> {
        if (requestParameters['registerRequestV2'] == null) {
            throw new runtime.RequiredError(
                'registerRequestV2',
                'Required parameter "registerRequestV2" was null or undefined when calling registerV2Post().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("ADB2CAuthFlow", ["https://nnczcustomerportaldev.onmicrosoft.com/5d23dca9-d19b-4c16-b403-d27b86222083/CustPortalApi.Default"]);
        }


        let urlPath = `/v2/register`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: RegisterRequestV2ToJSON(requestParameters['registerRequestV2']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RegisterResponseV2FromJSON(jsonValue));
    }

    /**
     * Try resolve information from registration into a MPK
     */
    async registerV2Post(requestParameters: RegisterV2PostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RegisterResponseV2> {
        const response = await this.registerV2PostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Save additional register data
     */
    async saveAdditionalRegisterDataPostRaw(requestParameters: SaveAdditionalRegisterDataPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ActiveDirectoryUserIdResponse>> {
        if (requestParameters['additionalRegisterDataRequest'] == null) {
            throw new runtime.RequiredError(
                'additionalRegisterDataRequest',
                'Required parameter "additionalRegisterDataRequest" was null or undefined when calling saveAdditionalRegisterDataPost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/register-user-save-data`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AdditionalRegisterDataRequestToJSON(requestParameters['additionalRegisterDataRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ActiveDirectoryUserIdResponseFromJSON(jsonValue));
    }

    /**
     * Save additional register data
     */
    async saveAdditionalRegisterDataPost(requestParameters: SaveAdditionalRegisterDataPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ActiveDirectoryUserIdResponse> {
        const response = await this.saveAdditionalRegisterDataPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Save additional register data
     */
    async saveAdditionalRegisterDataV2PostRaw(requestParameters: SaveAdditionalRegisterDataV2PostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ActiveDirectoryUserIdResponse>> {
        if (requestParameters['additionalRegisterDataRequest'] == null) {
            throw new runtime.RequiredError(
                'additionalRegisterDataRequest',
                'Required parameter "additionalRegisterDataRequest" was null or undefined when calling saveAdditionalRegisterDataV2Post().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/v2/register-user-save-data`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AdditionalRegisterDataRequestToJSON(requestParameters['additionalRegisterDataRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ActiveDirectoryUserIdResponseFromJSON(jsonValue));
    }

    /**
     * Save additional register data
     */
    async saveAdditionalRegisterDataV2Post(requestParameters: SaveAdditionalRegisterDataV2PostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ActiveDirectoryUserIdResponse> {
        const response = await this.saveAdditionalRegisterDataV2PostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Validate provided birth number againts AD B2C
     */
    async validateBirthNumberPostRaw(requestParameters: ValidateBirthNumberPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['validateBirthNumberRequest'] == null) {
            throw new runtime.RequiredError(
                'validateBirthNumberRequest',
                'Required parameter "validateBirthNumberRequest" was null or undefined when calling validateBirthNumberPost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/validate-birth-number`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ValidateBirthNumberRequestToJSON(requestParameters['validateBirthNumberRequest']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Validate provided birth number againts AD B2C
     */
    async validateBirthNumberPost(requestParameters: ValidateBirthNumberPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.validateBirthNumberPostRaw(requestParameters, initOverrides);
    }

    /**
     * Validate provided email againts AD B2C
     */
    async validateLocalAccountPostRaw(requestParameters: ValidateLocalAccountPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ValidateLocalAccountResponse>> {
        if (requestParameters['validateLocalAccountRequest'] == null) {
            throw new runtime.RequiredError(
                'validateLocalAccountRequest',
                'Required parameter "validateLocalAccountRequest" was null or undefined when calling validateLocalAccountPost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/validate-local-account`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ValidateLocalAccountRequestToJSON(requestParameters['validateLocalAccountRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ValidateLocalAccountResponseFromJSON(jsonValue));
    }

    /**
     * Validate provided email againts AD B2C
     */
    async validateLocalAccountPost(requestParameters: ValidateLocalAccountPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ValidateLocalAccountResponse> {
        const response = await this.validateLocalAccountPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
